import { createUseStyles } from 'react-jss';
import { Dialog, styled } from '@mui/material';
import { ITheme } from '../../theme';

export const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

export const dialogStyles = { m: 0, p: 2 };

type RuleNames =
  | 'uploadBtn'
  | 'modal'
  | 'modalTitle'
  | 'modalMainTitle'
  | 'cancelBtn'
  | 'image'
  | 'imageError';

const PREFIX = 'ModalUpload';
export const useStyles = createUseStyles<RuleNames, unknown, ITheme>(
  (theme: ITheme) => (
    {
      modal: {
        '& .MuiDialog-paper': {
          width: '468px',
          maxWidth: '468px',
          borderRadius: '20px',
        },
        '& .MuiDialogContent-root': {
          padding: '0 40px 40px 40px',
        },
        '& .MuiDialogTitle-root': {
          padding: '40px 40px 0px 40px',
        },
        '& .MuiDialogActions-root': {
          padding: '0px 40px 60px',
        },
      },
      uploadBtn: {
        backgroundColor: theme.black,
      },
      modalTitle: {
        color: 'rgba(0, 0, 0, 0.5)',
        fontSize: '13px',
        margin: '20px 0',
      },
      modalMainTitle: {
        fontSize: '36px',
        fontWeight: 600,
      },
      cancelBtn: {
        color: theme.black,
        background: theme.white,
        border: '1px solid black',
      },
      image: {
        width: '388px',
        height: '322px',
        position: 'relative',
        borderRadius: '5px',
      },
      imageError: {
        width: '388px',
        height: '322px',
        marginTop: '4px',
        border: '1px solid grey',
        borderRadius: '5px',
      },
    }
  ),
  { name: PREFIX },
);
